import { transitionManager } from './transitionManager'
import { components } from '../shared/components'
import { trackAction } from '../shared/utils/googleAnalytics'

let currentSection = null

export const intersectionObserverCallback = (changes, state, dispatch) => {
  if (!changes) return

  const sections = state.sections

  // Update state
  changes.forEach(change => {
    const changedElement = sections.find(
      ({ foregroundElement }) => change.target === foregroundElement
    )
    changedElement.isIntersecting = change.isIntersecting
  })

  const nextSection = sections.filter(e => e.isIntersecting).pop()

  if (
    !currentSection ||
    currentSection.foregroundElement !== nextSection.foregroundElement
  ) {
    trackAction(
      `LOAD_SUCCESS/${nextSection.foregroundElement.getAttribute('data-background-id')}`
    )

    const currentIndex = sections.indexOf(nextSection)
    const previousIndex = currentSection ? sections.indexOf(currentSection) : null

    const direction = currentIndex > previousIndex ? 'forwards' : 'backwards'

    const previousSection = sections[previousIndex]

    currentSection = nextSection

    transitionManager(nextSection, previousSection, direction)

    dispatch({ type: 'showShareButtons', value: nextSection.props.shareIcons })
    components.filter(component => component.onCurrentChanged).forEach(component => {
      component.onCurrentChanged(nextSection, dispatch)
    })
  }
}



// WEBPACK FOOTER //
// ./src/client/intersection.js